import * as Yup from 'yup'

export const ClientSchema = Yup.object().shape({
  name: Yup.string().required('This field is required.'),
});
